<!--
 * @Author: ZJJ
 * @Date: 2025-11-05 19:13:16
 * @LastEditTime: 2025-11-26 15:03:38
 * @FilePath: /boluo_website/src/App.vue
 * @Description: 
-->
<template>
  <div id="app">
    <router-view />

    <!-- 全局音频播放器 -->
    <audio-player-bar />

    <!-- 二维码支付模块 -->
    <Pay
      v-if="isShowPayDialog"
      :payType="payType"
      :lessionOrAudioBookId="lessionOrAudioBookId"
    ></Pay>
  </div>
</template>
<script>
// 导入整个模块，兼容生产环境构建
import * as thumbmarkjs from "@thumbmarkjs/thumbmarkjs";
import AudioPlayerBar from "@/components/AudioPlayer/AudioPlayerBar.vue";
import audioManagerInit from "@/mixins/audioManagerInit";

import Pay from "./components/public/pay.vue";

import { mapState } from "vuex";

export default {
  name: "App",
  mixins: [audioManagerInit],
  components: {
    AudioPlayerBar,
    Pay
  },
  data() {
    return {};
  },
  async created() {
    // sign 应该从登录接口响应中获取并存储到 localStorage
    // 或者如果后端通过 httpOnly cookie 设置，前端无法读取，只能从 localStorage 读取
    // 此处不需要从 cookie 同步，因为拦截器会直接从 localStorage 读取

    try {
      // 兼容不同的导出方式（处理 CommonJS 和 ES6 模块）
      let generateFingerprint = thumbmarkjs.generateFingerprint;

      // 如果没有找到，尝试其他可能的导出方式
      if (!generateFingerprint || typeof generateFingerprint !== "function") {
        generateFingerprint =
          thumbmarkjs.default?.generateFingerprint || thumbmarkjs.default;
      }

      if (typeof generateFingerprint === "function") {
        let finger =
          localStorage.getItem("fingerPrint") || (await generateFingerprint());
        localStorage.setItem("fingerPrint", finger);
      } else {
        throw new Error("generateFingerprint is not a function");
      }
    } catch (error) {
      // console.error("Failed to generate fingerprint:");
      // 降级处理：如果生成失败，使用时间戳作为临时标识
      if (!localStorage.getItem("fingerPrint")) {
        localStorage.setItem("fingerPrint", Date.now().toString());
      }
    }
  },
  mounted() {},
  methods: {},
  computed: {
    ...mapState(["isShowPayDialog", "payType", "lessionOrAudioBookId"])

    // payType: 0,//当前需要被付款的类型 (1=有声书, 2=课程)
    // lessionOrAudioBookId: 0, // 付款的课程或有声书的id
  }
};
</script>

<style lang="less" scoped></style>
